import React from "react";
import { API_URL } from "../../../constants/api";
import { apiPost } from "../../../utils/api_service";
import { encodeEmail, validatePassword } from "../../../utils/generic";
import { ShowToast, toastType } from "../../../utils/toast-service";
import ValidateOtp from "../ValidateOtp/ValidateOtp";

class PasswordReset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      view: "reset",
      email: null,
      password: "string",
      repeatPassword: null,
      phoneNumber: null,
    };
  }

  /** reset password */
  resetPassword = () => {
    if (this.state.email == null || this.state.email == "") {
      ShowToast("Please enter username", toastType.ERROR, 5000, 200);
      return false;
    }

    const postBody = {
      email: this.state.email,
      password: this.state.password,
      otp: "string",
    };
    apiPost({
      url: API_URL.tenant.ForgotPassword,
      postBody: postBody,
    }).then((response) => {
      if (response.data.success == false) {
        ShowToast(response.data.message, toastType.ERROR, 5000, 200);
      } else if (response.data.success == true) {
        this.setState({ view: "otp", phoneNumber: response.data.data });
        ShowToast(response.data.message, toastType.SUCCESS, 5000, 200);
      }
    });
  };

  /** Verify OTP */
  verifyOTP = (otp) => {
    if (this.state.password == null || this.state.password == "") {
      ShowToast("Please enter the password", toastType.ERROR, 5000, 200);
      return false;
    } else if (
      this.state.repeatPassword == null ||
      this.state.repeatPassword == ""
    ) {
      ShowToast("Please enter the repeat password", toastType.ERROR, 5000, 200);
      return false;
    }

    if (this.state.password !== this.state.repeatPassword) {
      ShowToast("Password do not match", toastType.ERROR, 5000, 200);
      return false;
    }
    if (
      validatePassword(this.state.password) == false ||
      validatePassword(this.state.repeatPassword) == false
    ) {
      ShowToast(
        "Password/Repeat Password must be 8 to 12 alphanumeric characters and at-least one of the special characters in (!,@,#,$,%,^,&,*) ",
        toastType.ERROR,
        5000,
        200
      );
      return false;
    }

    if (otp == "") {
      ShowToast(
        "Please enter one time password (OTP) ",
        toastType.ERROR,
        5000,
        200
      );
    }

    const postBody = {
      email: this.state.email,
      password: this.state.password,
      otp: otp,
      type: "RESET",
    };
    apiPost({
      url: API_URL.tenant.VerifyOTP,
      postBody: postBody,
    }).then((response) => {
      if (response.data.success == false) {
        ShowToast(response.data.message, toastType.ERROR, 5000, 200);
      } else if (response.data.success == true) {
        ShowToast(
          "Password has been successfully updated",
          toastType.SUCCESS,
          5000,
          200
        );
        this.props.resetPassword("logIn");
      }
    });
  };

  /** Resend OTP */
  resendOTP = (opt) => {
    const postBody = {
      email: this.state.email,
      password: this.state.password,
      otp: opt,
      type: "RESET",
    };
    apiPost({
      url: API_URL.tenant.ResendOTP,
      postBody: postBody,
    }).then((response) => {
      if (response.data.success == true) {
        ShowToast("OTP sent successfully", toastType.SUCCESS, 5000, 200);
      } else {
        ShowToast(
          "There is issue with sending OTP",
          toastType.SUCCESS,
          5000,
          200
        );
      }

      //console.log(response);
    });
  };

  /** Set values */
  setValues = (value, FieldName) => {
    if (FieldName == "email") {
      this.setState({ email: value });
    } else if (FieldName == "password") {
      this.setState({ password: value });
    } else if (FieldName == "repeatPassword") {
      this.setState({ repeatPassword: value });
    }
  };

  render() {
    return (
      <>
        {this.state.view == "reset" ? (
          <div>
            <div>
              <label>{"Username"}</label>
              <br />
              <input
                type={"text"}
                name={"Full Name"}
                className={"text-field "}
                onBlur={(event) => {
                  this.setValues(event.target.value, "email");
                }}
              />
            </div>

            <div>
              <button type={"button"}
                className={"login-button"}
                onClick={() => this.resetPassword()}
              >
                {"Submit\r"}
              </button>
              &nbsp;&nbsp;
              <button type={"button"}
                className={"login-button"}
                onClick={() => this.props.resetPassword("logIn")}
              >
                {"Back\r"}
              </button>
            </div>
          </div>
        ) : (
          <>
            <div>
              <label>{"New Password"}</label> <br />
              <input
                type={"password"}
                name={"Email Address"}
                className={"text-field "}
                onBlur={(event) => {
                  event.target.value != ""
                    ? this.setValues(event.target.value, "password")
                    : ShowToast(
                        "Please enter password",
                        toastType.ERROR,
                        5000,
                        200
                      );
                }}
              />
            </div>

            <div>
              <label>{"Repeat Password"}</label> <br />
              <input
                type={"password"}
                name={"password"}
                className={"text-field "}
                onBlur={(event) => {
                  event.target.value != ""
                    ? this.setValues(event.target.value, "repeatPassword")
                    : ShowToast(
                        "Please enter the password",
                        toastType.ERROR,
                        5000,
                        200
                      );
                }}
              />
            </div>
            <ValidateOtp
              email={encodeEmail(this.state.email)}
              verifyOTP={this.verifyOTP}
              resendOTP={this.resetPassword}
              phoneNumber={this.state.phoneNumber}
            />
          </>
        )}
      </>
    );
  }
}

export default PasswordReset;
